//
//
//
//
//
//
//


import auth from '@/modules/Auth'

export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    authenticated () {
      return auth.check()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Activated.vue